function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import { EventEmitter } from 'events';

var Evented = /*#__PURE__*/function (_EventEmitter) {
  _inheritsLoose(Evented, _EventEmitter);

  function Evented() {
    var _this;

    _this = _EventEmitter.apply(this, arguments) || this;
    _this.internalEventListeners = [];
    return _this;
  }

  var _proto = Evented.prototype;

  _proto.listenTo = function listenTo(target, event, handler) {
    this.internalEventListeners.push({
      target: target,
      event: event,
      handler: handler
    });
    target.on(event, handler);
  };

  _proto.stopListening = function stopListening(target, event, handler) {
    var i = 0;

    while (i < this.internalEventListeners.length) {
      var listener = this.internalEventListeners[i];

      if ((!target || listener.target === target) && (!event || listener.event === event) && (!handler || listener.handler === handler)) {
        listener.target.removeListener(listener.event, listener.handler);
        this.internalEventListeners.splice(i, 1);
      } else {
        i++;
      }
    }
  };

  return Evented;
}(EventEmitter);

export { Evented as default };